<template>
  <div class="container-fluid mt-4" :class="themeClass">
    <div class="card shadow-sm">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">
          <i class="bi bi-eye me-2"></i>
          Ver Cliente
        </h5>
        <div>
          <router-link :to="`/clientes/editar/${clienteId}`" class="btn btn-warning me-2">
            <i class="bi bi-pencil me-1"></i>
            Editar
          </router-link>
          <router-link to="/clientes" class="btn btn-secondary">
            <i class="bi bi-arrow-left me-1"></i>
            Volver al Listado
          </router-link>
        </div>
      </div>
      <div class="card-body">
        <!-- Mensaje de error -->
        <div v-if="error" class="alert alert-danger" role="alert">
          <i class="bi bi-exclamation-triangle me-2"></i>
          {{ error }}
          <button type="button" class="btn btn-sm btn-outline-danger ms-2" @click="loadCliente">
            <i class="bi bi-arrow-clockwise"></i> Reintentar
          </button>
        </div>

        <!-- Indicador de carga -->
        <div v-if="loading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mt-2 text-muted">Cargando cliente...</p>
        </div>

        <!-- Contenido del cliente -->
        <div v-else-if="cliente">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <!-- Información General -->
                <div class="col-lg-6">
                  <h6 class="mb-3">
                    <i class="bi bi-person me-2"></i>
                    Información General
                  </h6>
                  <div class="row g-3">
                    <div class="col-md-4">
                      <div class="mb-2">
                        <label class="form-label fw-bold text-muted small">Tipo de Identificación</label>
                        <p class="mb-0">{{ getTipoIdNombre(cliente.tipoId) }}</p>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-2">
                        <label class="form-label fw-bold text-muted small">Número de Identificación</label>
                        <p class="mb-0">{{ cliente.identificacion }}</p>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-2">
                        <label class="form-label fw-bold text-muted small">Razón Social / Nombre</label>
                        <p class="mb-0">{{ cliente.razonSocial }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Información de Contacto y Dirección -->
                <div class="col-lg-6">
                  <h6 class="mb-3">
                    <i class="bi bi-telephone me-2"></i>
                    Información de Contacto
                  </h6>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label fw-bold text-muted small">Correo Electrónico</label>
                        <p class="mb-0">{{ cliente.correo || 'No especificado' }}</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label fw-bold text-muted small">Teléfono</label>
                        <p class="mb-0">{{ cliente.telefono || 'No especificado' }}</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="mb-2">
                        <label class="form-label fw-bold text-muted small">Dirección</label>
                        <p class="mb-0">{{ cliente.direccion || 'No especificada' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmación de Eliminación -->
    <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmDeleteModalLabel">
              <i class="bi bi-exclamation-triangle text-danger me-2"></i>
              Confirmar Eliminación
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="mb-0">
              ¿Está seguro de que desea eliminar al cliente <strong>{{ cliente?.razonSocial }}</strong>?
            </p>
            <p class="text-muted small mt-2">
              Esta acción no se puede deshacer.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-lg me-1"></i>
              Cancelar
            </button>
            <button type="button" class="btn btn-danger" @click="confirmarEliminar" :disabled="eliminando">
              <i class="bi bi-trash me-1"></i>
              {{ eliminando ? 'Eliminando...' : 'Eliminar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeManager from '@/store/theme'
import { clientService } from '@/services/clientService'
import api from '@/services/api'
import { Modal } from 'bootstrap'

export default {
  name: 'ClientClientesVer',
  props: ['id'],
  computed: {
    themeClass() {
      return themeManager.themeClass
    },
    clienteId() {
      return this.$route.params.id || this.id
    }
  },
  data() {
    return {
      tiposIdentificacion: [],
      cliente: null,
      loading: false,
      error: null,
      eliminando: false
    }
  },
  async mounted() {
    this.fetchTiposIdentificacion()
    await this.loadCliente()
  },
  methods: {
    async fetchTiposIdentificacion() {
      try {
        const res = await api.get('/tipos-identificacion-sri')
        this.tiposIdentificacion = res.data?.data || []
      } catch (e) {
        console.error('Error cargando tipos de identificación', e)
      }
    },
    async loadCliente() {
      try {
        this.loading = true
        this.error = null

        console.log('Cargando cliente con ID:', this.clienteId)
        const response = await clientService.getClient(this.clienteId)
        console.log('Respuesta de la API:', response)

        if (!response.data) {
          throw new Error('No se encontraron datos del cliente')
        }

        this.cliente = this.mapClienteData(response.data)
        console.log('Cliente cargado:', this.cliente)

      } catch (error) {
        console.error('Error loading client:', error)
        console.error('Detalles del error:', error.response || error)

        // Manejo más específico de errores
        if (error.response) {
          if (error.response.status === 404) {
            this.error = `Cliente con ID ${this.clienteId} no encontrado`
          } else if (error.response.status === 403) {
            this.error = 'No tienes permisos para ver este cliente'
          } else if (error.response.status >= 500) {
            this.error = 'Error del servidor. Inténtalo más tarde'
          } else {
            this.error = `Error al cargar el cliente: ${error.response.data?.message || 'Error desconocido'}`
          }
        } else if (error.request) {
          this.error = 'No se pudo conectar con el servidor'
        } else {
          this.error = `Error: ${error.message}`
        }

        this.cliente = null
      } finally {
        this.loading = false
      }
    },

    mapClienteData(apiData) {
      return {
        id: apiData.id,
        tipoId: apiData.tipo_identificacion || '',
        identificacion: apiData.identification_number || '',
        razonSocial: apiData.business_name || '',
        telefono: apiData.phone || '',
        correo: apiData.email || '',
        direccion: apiData.address || ''
      }
    },

    getTipoIdNombre(codigo) {
      const tipo = this.tiposIdentificacion.find(t => t.codigo === codigo)
      return tipo ? tipo.tipo_de_identificacion : (codigo || '-')
    },

    async eliminarCliente() {
      // Mostrar el modal de confirmación
      const modal = new Modal(document.getElementById('confirmDeleteModal'))
      modal.show()
    },

    async confirmarEliminar() {
      try {
        this.eliminando = true

        await clientService.deleteClient(this.cliente.id)

        // Cerrar el modal
        const modal = Modal.getInstance(document.getElementById('confirmDeleteModal'))
        modal.hide()

        // Mostrar notificación de éxito
        this.$emit('show-notification', {
          type: 'success',
          message: `Cliente ${this.cliente.razonSocial} eliminado exitosamente`
        })

        // Redirigir a la lista
        this.$router.push('/clientes')

      } catch (error) {
        console.error('Error deleting client:', error)

        // Cerrar el modal
        const modal = Modal.getInstance(document.getElementById('confirmDeleteModal'))
        modal.hide()

        // Mostrar notificación de error
        this.$emit('show-notification', {
          type: 'error',
          message: 'Error al eliminar el cliente. Inténtalo de nuevo.'
        })
      } finally {
        this.eliminando = false
      }
    },

  }
}
</script>

<style scoped>
/* Estilos para modo oscuro */
.dark-theme .card {
  background-color: var(--card-bg);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.dark-theme .card-header {
  background-color: var(--card-header-bg);
  border-bottom-color: var(--border-color);
  color: var(--text-primary);
}

.dark-theme .form-label {
  color: var(--text-primary);
}

/* Estilos específicos del componente */
.card {
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.dark-theme .card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0 !important;
  padding: 1.5rem;
}

.card-body {
  padding: 2rem;
}

.btn {
  border-radius: 8px;
  font-weight: 500;
}

.badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.5rem;
}

@media (max-width: 768px) {
  .card-body {
    padding: 1rem;
  }

  .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
</style>

